import { render, staticRenderFns } from "./obitosRegularizados.vue?vue&type=template&id=7bb7ebe6"
import script from "./obitosRegularizados.vue?vue&type=script&lang=js"
export * from "./obitosRegularizados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports